import Inverter from "./common/auxiliaries/InverterIcon.svg?react";
import Tracker from "./common/auxiliaries/TrackerIcon.svg?react";
import DataPointErrorIcon from "./common/error/DataPointErrorIcon.svg?react";
import EmergencyErrorHover from "./common/error/emergency/EmergencyErrorHover.svg?react";
import EmergencyErrorIcon from "./common/error/emergency/EmergencyErrorIcon.svg?react";
import HighSeverityError from "./common/error/HighSeverityErrorIcon.svg?react";
import LowSeverityError from "./common/error/LowSeverityErrorIcon.svg?react";
import MildSeverityError from "./common/error/MildSeverityErrorIcon.svg?react";
import MultisiteHighSeverityError from "./common/error/multisite/HighSeverityErrorIcon.svg?react";
import MultisiteLowSeverityError from "./common/error/multisite/LowSeverityErrorIcon.svg?react";
import MultisiteMildSeverityError from "./common/error/multisite/MildSeverityErrorIcon.svg?react";
import MultisiteUndefinedSeverityError from "./common/error/multisite/UndefinedErrorIcon.svg?react";
import UndefinedSeverityError from "./common/error/UndefinedErrorIcon.svg?react";
import ArrowDownDisabled from "./common/fields/ArrowDownDisabledIcon.svg?react";
import FocusedArrowDown from "./common/fields/ArrowDownFocusedIcon.svg?react";
import ArrowDown from "./common/fields/ArrowDownIcon.svg?react";
import Calender from "./common/fields/CalenderIcon.svg?react";
import ListItemSelected from "./common/fields/ListItemSelectedIcon.svg?react";
import CloseIcon from "./common/file-commands/CloseIcon.svg?react";
import Delete from "./common/file-commands/DeleteIcon.svg?react";
import DeleteDisabled from "./common/file-commands/DeleteDisabledIcon.svg?react";
import DownloadDisabled from "./common/file-commands/DownloadDisabledIcon.svg?react";
import Download from "./common/file-commands/DownloadIcon.svg?react";
import SendIcon from "./common/file-commands/SendIcon.svg?react";
import UploadDisabled from "./common/file-commands/UploadDisabledIcon.svg?react";
import Upload from "./common/file-commands/UploadIcon.svg?react";
import WhiteSendIcon from "./common/file-commands/WhiteSendIcon.svg?react";
import WhiteUpload from "./common/file-commands/WhiteUploadIcon.svg?react";
import ChartLoader from "./common/loaders/ChartsLoader.svg?react";
import ChartCardSkeleton from "./common/loaders/ChartCardSkeleton.svg?react";
import WindChartSkeleton from "./common/loaders/WindChartSkeleton.svg?react";
import NoIssuesIcon from "./common/status/NoIssuesIcon.svg?react";
import InverterPerformanceChartSkeleton from "./common/loaders/InverterPerformanceChartSkeleton.svg?react";
import CumulativeProductionSkeleton from "./common/loaders/CumulativeProductionChartSkeleton.svg?react";
import Separator from "./common/Separator.svg?react";
import Logo from "./common/SolarGikLogo.svg?react";
import HeaderLogo from "./common/HeaderSolargikLogo.svg?react";
import ACPower from "./common/soma/agri/AcPowerIcon.svg?react";
import BarometricPressure from "./common/soma/agri/BarometricPressureIcon.svg?react";
import Photosyn from "./common/soma/agri/PhotosynIcon.svg?react";
import PlantGrowth from "./common/soma/agri/PlantGrowthIcon.svg?react";
import RainGouge from "./common/soma/agri/RainGougeIcon.svg?react";
import ShadingZeroTwentyFive from "./common/soma/agri/shading0-25.svg?react";
import ShadingTwentyFiveFivty from "./common/soma/agri/shading25-50.svg?react";
import ShadingFivtySeventyFive from "./common/soma/agri/shading50-75.svg?react";
import ShadingSeventyFiveHundred from "./common/soma/agri/shading75-100.svg?react";
import Soil from "./common/soma/agri/SoilIcon.svg?react";
import ClosedEye from "./common/soma/trends/ClosedEyeIcon.svg?react";
import EditLine from "./common/soma/trends/EditLineIcon.svg?react";
import OpenedEye from "./common/soma/trends/OpenedEyeIcon.svg?react";
import Plus from "./common/soma/trends/PlusIcon.svg?react";
import UserRecordsButtonIcon from "./common/soma/user-records/UserRecordIcon.svg?react";
import UserRecordsDisabledIcon from "./common/soma/user-records/UserRecordsDisabledIcon.svg?react";
import Battery from "./common/status/BatteryStatusIcon.svg?react";
import Grid from "./common/status/GridStatusIcon.svg?react";
import BatteryInvalid from "./common/status/invalid/BatteryStatusIcon.svg?react";
import GridInvalid from "./common/status/invalid/GridStatusIcon.svg?react";
import StatusInverter from "./common/status/InverterStatusIcon.svg?react";
import Error from "./common/status/multisite/StatusError.svg?react";
import Ok from "./common/status/multisite/StatusOk.svg?react";
import Undefined from "./common/status/multisite/StatusUndefined.svg?react";
import Warning from "./common/status/multisite/StatusWarning.svg?react";
import StatusMark from "./common/status/StatusMarkIcon.svg?react";
import StatusTracker from "./common/status/TrackerStatusIcon.svg?react";
import UserIcon from "./common/UserIcon.svg?react";
import MaintenanceReason from "./common/reason/Maintenance.svg?react";
import SnowReason from "./common/reason/Snow.svg?react";
import SoftwareReason from "./common/reason/Software.svg?react";
import SprinklersReason from "./common/reason/Sprinklers.svg?react";
import TrackerReason from "./common/reason/Tracker.svg?react";
import WindReason from "./common/reason/Wind.svg?react";
import UpsReason from "./common/reason/Ups.svg?react";
import UserReason from "./common/reason/User.svg?react";
import ForecastSafetyIcon from "./common/reason/WindForecastSafety.svg?react";
import SnowForecastSafetyIcon from "./common/reason/SnowForecastSafety.svg?react";
import EngineerReason from "./common/reason/Engineer.svg?react";
import BarometricPressureInvalid from "./common/soma/agri/invalid/BarometricPressureIcon.svg?react";
import SoilInvalid from "./common/soma/agri/invalid/SoilIcon.svg?react";
import ACPowerInvalid from "./common/soma/agri/invalid/AcPowerIcon.svg?react";
import RainGougeInvalid from "./common/soma/agri/invalid/RainGougeIcon.svg?react";
import PhotosynInvalid from "./common/soma/agri/invalid/PhotosynIcon.svg?react";
import PlantGrowthInvalid from "./common/soma/agri/invalid/PlantGrowthIcon.svg?react";
import Connector from "./common/soma/agri/Connector.svg?react";
import Clock from "./common/soma/agri/ClockIcon.svg?react";
import WhiteDownload from "./common/file-commands/WhiteDownload.svg?react";
import TrackerBattery from "./common/TrackerBatteryIcon.svg?react";
import ExistsScheduledCommandIcon from "./common/navigation/ScheduleCommand/ExistsScheduledCommandIcon.svg?react";
import RecurrenceIcon from "./common/navigation/ScheduleCommand/Recurrence.svg?react";
import ActiveScheduledCommandIcon from "./common/navigation/ScheduleCommand/ActiveScheduledCommandIcon.svg?react";
import RightArrow from "./common/RightArrow.svg?react";
import SprinklersIcon from "./common/soma/sprinklers/SprinklerIcon.svg?react";
import DiffuseOptimizationOn from "./common/diffuseOptimization/DiffuseOptimizationOn.svg?react";
import GridDelete from "./common/grid/Delete.svg?react";
import GridEdit from "./common/grid/Edit.svg?react";
import SafeOverridePopUpIcon from "./common/status/SafeOverridePopUpIcon.svg?react";
import MutedIcon from "./AlertIcons/MutedAlert.svg?react";
import UnmutedIcon from "./AlertIcons/UnmutedAlert.svg?react";
import ProductionVsIrradianceSkeleton from "./common/loaders/ProductionVsIrradianceSkeleton.svg?react";
import TrackerStatesSkeleton from "./common/loaders/TrackerStatesSkeleton.svg?react";
import TopIssuesServerErrorIcon from "./common/status/TopIssuesServerErrorIcon.svg?react";
import AvailableSolarEnergyIcon from "./common/lossAnalysis/AvailableSolarEnergy.svg?react";
import ActualProductionIcon from "./common/lossAnalysis/ActualProduction.svg?react";
import LossesIcon from "./common/lossAnalysis/Losses.svg?react";
import EmptyStateIcon from "./common/lossAnalysis/EmptyState.svg?react";
import { IconCategory } from "./IconsModels";
import { Theme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";
import headerLogoClasses from "./HeaderLogo.module.css";

interface IconSet {
  [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const responsiveIcon = (
  Icon: IconSet[string],
  sx: SystemStyleObject<Theme>,
  defaults?: React.SVGProps<SVGSVGElement>
): IconSet[string] => {
  const StyledIcon = styled(Icon)({});
  const ResponsiveIcon: IconSet[string] = (props) => (
    <StyledIcon
      sx={{
        ...sx,
        ...(props.width != null && { width: props.width }),
        ...(props.height != null && { height: props.height }),
        ...(props.strokeWidth != null && { strokeWidth: props.strokeWidth }),
      }}
      {...defaults}
      {...props}
    />
  );
  return ResponsiveIcon;
};

const paddedResponsiveIcon = (Icon: IconSet[string], sx: SystemStyleObject<Theme>): IconSet[string] =>
  responsiveIcon(Icon, { padding: { xs: "0px", lg: "5px" }, ...sx });

const createIcon = (iconName: string, iconCategory: IconCategory) => {
  const getReasonIcons = (): IconSet => ({
    Wind: paddedResponsiveIcon(WindReason, {
      width: { xs: 16, lg: 24 },
      height: { xs: 16, lg: 24 },
    }),
    Snow: paddedResponsiveIcon(SnowReason, {
      width: { xs: 16, lg: 22 },
      height: { xs: 16, lg: 22 },
    }),
    Sprinklers: paddedResponsiveIcon(SprinklersReason, {
      width: { xs: 16, lg: 22 },
      height: { xs: 16, lg: 22 },
    }),
    Tracker: paddedResponsiveIcon(TrackerReason, {
      width: { xs: 16, lg: 24 },
      height: { xs: 16, lg: 24 },
    }),
    Maintenance: paddedResponsiveIcon(MaintenanceReason, {
      width: { xs: 16, lg: 22 },
      height: { xs: 16, lg: 22 },
    }),
    Software: paddedResponsiveIcon(SoftwareReason, {
      width: { xs: 16, lg: 24 },
      height: { xs: 16, lg: 24 },
    }),
  });

  const getSafetyReasonIcons = (): IconSet => ({
    Wind: paddedResponsiveIcon(WindReason, {
      width: { xs: 16, lg: 18 },
      height: { xs: 16, lg: 18 },
    }),
    Snow: paddedResponsiveIcon(SnowReason, {
      width: { xs: 16, lg: 18 },
      height: { xs: 16, lg: 18 },
    }),
    Ups: paddedResponsiveIcon(UpsReason, {
      width: { xs: 16, lg: 14 },
      height: { xs: 16, lg: 14 },
    }),
    Engineer: paddedResponsiveIcon(EngineerReason, {
      width: { xs: 16, lg: 14 },
      height: { xs: 16, lg: 14 },
    }),
    User: paddedResponsiveIcon(UserReason, {
      width: { xs: 16, lg: 14 },
      height: { xs: 16, lg: 14 },
    }),
    WindForecastSafety: paddedResponsiveIcon(ForecastSafetyIcon, {
      width: { xs: 16, lg: 14 },
      height: { xs: 16, lg: 14 },
    }),
    SnowForecastSafety: paddedResponsiveIcon(SnowForecastSafetyIcon, {
      width: { xs: 16, lg: 14 },
      height: { xs: 16, lg: 14 },
    }),
  });

  const getAuxiliariesIcons = (): IconSet => ({
    Inverter: Inverter,
    Tracker: Tracker,
  });

  const getSomaIcons = (): IconSet => {
    return {
      // agri data point
      ACPower: responsiveIcon(ACPower, { width: { xs: 13.5, lg: 18 }, height: { xs: 18.75, lg: 25 } }),
      ACPowerInvalid: responsiveIcon(ACPowerInvalid, {
        width: { xs: 21, lg: 28 },
        height: { xs: 22.5, lg: 30 },
      }),
      BarometricPressure: responsiveIcon(BarometricPressure, {
        width: { xs: 18, lg: 24 },
        height: { xs: 15, lg: 20 },
      }),
      BarometricPressureInvalid: responsiveIcon(BarometricPressureInvalid, {
        width: { xs: 27, lg: 36 },
        height: { xs: 21, lg: 28 },
      }),
      Photosyn: responsiveIcon(Photosyn, { width: { xs: 18, lg: 24 }, height: { xs: 18, lg: 24 } }),
      PhotosynInvalid: responsiveIcon(PhotosynInvalid, {
        width: { xs: 33, lg: 44 },
        height: { xs: 29.25, lg: 39 },
      }),
      PlantGrowth: responsiveIcon(PlantGrowth, {
        width: { xs: 15, lg: 20 },
        height: { xs: 15, lg: 20 },
      }),
      PlantGrowthInvalid: responsiveIcon(PlantGrowthInvalid, {
        width: { xs: 20.25, lg: 27 },
        height: { xs: 23.25, lg: 31 },
      }),
      RainGouge: responsiveIcon(RainGouge, { width: { xs: 15, lg: 20 }, height: { xs: 18, lg: 24 } }),
      RainGougeInvalid: responsiveIcon(RainGougeInvalid, {
        width: { xs: 24.75, lg: 33 },
        height: { xs: 22.5, lg: 30 },
      }),
      Soil: responsiveIcon(Soil, { width: { xs: 22.5, lg: 30 }, height: { xs: 27.75, lg: 37 } }),
      SoilInvalid: responsiveIcon(SoilInvalid, {
        width: { xs: 32.25, lg: 43 },
        height: { xs: 33, lg: 44 },
      }),

      // agri shading plan
      Shading025: responsiveIcon(ShadingZeroTwentyFive, {
        width: { xs: 237, lg: 404 },
        height: { xs: 68, lg: 116 },
      }),
      Shading2550: responsiveIcon(ShadingTwentyFiveFivty, {
        width: { xs: 237, lg: 404 },
        height: { xs: 68, lg: 116 },
      }),
      Shading5075: responsiveIcon(ShadingFivtySeventyFive, {
        width: { xs: 237, lg: 404 },
        height: { xs: 68, lg: 116 },
      }),
      Shading75100: responsiveIcon(ShadingSeventyFiveHundred, {
        width: { xs: 257, lg: 404 },
        height: { xs: 75, lg: 114 },
      }),
      Connector: responsiveIcon(Connector, {
        width: { xs: 23, lg: 68 },
        height: { xs: 24, lg: 72 },
        strokeWidth: { xs: 5, lg: 1 },
      }),
      Clock: Clock,

      //sprinklers
      SprinklerOn: responsiveIcon(
        SprinklersIcon,
        { width: { xs: 28, lg: 46 }, height: { xs: 24, lg: 40 } },
        { fill: "#7cdeaf" }
      ),
      SprinklerOff: responsiveIcon(
        SprinklersIcon,
        { width: { xs: 28, lg: 46 }, height: { xs: 24, lg: 40 } },
        { fill: "#d0d0d0" }
      ),

      // trends-unresponsive
      ClosedEye: ClosedEye,
      OpenedEye: OpenedEye,

      // trends-responsive
      Plus: responsiveIcon(Plus, { width: { xs: 85, lg: 131 }, height: { xs: 85, lg: 131 } }),
      EditLine: paddedResponsiveIcon(EditLine, {
        width: { xs: 16, lg: 24 },
        height: { xs: 16, lg: 24 },
      }),
      AlertMuted: responsiveIcon(MutedIcon, { width: { xs: 14, lg: 20 }, height: { xs: 14, lg: 20 } }),
      AlertUnmuted: responsiveIcon(UnmutedIcon, {
        width: { xs: 14, lg: 20 },
        height: { xs: 14, lg: 20 },
      }),
      NoIssues: responsiveIcon(NoIssuesIcon, {
        width: { xs: 100, lg: 140 },
        height: { xs: 100, lg: 140 },
      }),
      TopIssuesServerErrorIcon: responsiveIcon(TopIssuesServerErrorIcon, {
        width: { xs: 70, lg: 100 },
        height: { xs: 70, lg: 100 },
      }),
    };
  };

  const getLoadersIcons = (): IconSet => ({
    ChartLoader: ChartLoader,
    ChartCardSkeleton: ChartCardSkeleton,
    TrackerStatesSkeleton: (props) => <TrackerStatesSkeleton {...props} />,
    WindChartSkeleton: (props) => <WindChartSkeleton {...props} />,
    InverterPerformanceSkeleton: (props) => <InverterPerformanceChartSkeleton {...props} />,
    ProductionVsIrradianceSkeleton: (props) => <ProductionVsIrradianceSkeleton {...props} />,
    CumulativeProductionSkeleton: (props) => <CumulativeProductionSkeleton {...props} />,
  });

  const getFileCommandsIcons = (): IconSet => ({
    Download: (props) => <Download fill="#2C3F81" {...props} />,
    WhiteDownload: WhiteDownload,
    DownloadDisabled: DownloadDisabled,
    Upload: Upload,
    WhiteUpload: WhiteUpload,
    UploadDisabled: UploadDisabled,
    Delete: Delete,
    DeleteDisabled: DeleteDisabled,
    Send: SendIcon,
    WhiteSend: responsiveIcon(WhiteSendIcon, { width: { xs: 13, lg: 16 }, height: { xs: 13, lg: 16 } }),
    Close: CloseIcon,
  });

  const getFieldsIcons = (): IconSet => ({
    ListItemSelected: ListItemSelected,
    ArrowDown: responsiveIcon(
      ArrowDown,
      { width: { xs: 12, lg: 16 }, height: { xs: 12, lg: 16 } },
      { fill: "#1F3171" }
    ),
    ArrowDownDisabled: responsiveIcon(ArrowDownDisabled, {
      width: { xs: 12, lg: 16 },
      height: { xs: 12, lg: 16 },
    }),
    FocusedArrowDown: responsiveIcon(FocusedArrowDown, {
      width: { xs: 12, lg: 16 },
      height: { xs: 12, lg: 16 },
    }),
    RightArrow: responsiveIcon(RightArrow, { width: { xs: 8, lg: 11 }, height: { xs: 11, lg: 14 } }),
    Calender: responsiveIcon(Calender, { width: { xs: 24, lg: 32 }, height: { xs: 24, lg: 32 } }),
  });

  const getGeneralIcons = (): IconSet => ({
    UserRecords: responsiveIcon(UserRecordsButtonIcon, {
      width: { xs: 24, lg: 32 },
      height: { xs: 24, lg: 32 },
    }),
    UserRecordsDisabled: responsiveIcon(UserRecordsDisabledIcon, {
      width: { xs: 24, lg: 32 },
      height: { xs: 24, lg: 32 },
    }),
    SolarGikLogo: (props) => <Logo width={90} height={24} {...props} />,
    HeaderSolargikLogo: (props) => (
      <HeaderLogo
        width={131}
        height={35}
        {...props}
        className={[headerLogoClasses.logo, props.className].filter(Boolean).join(" ")}
      />
    ),
    UserIcon: responsiveIcon(UserIcon, { width: { xs: 16, lg: 26 }, height: { xs: 16, lg: 26 } }),
    Separator: responsiveIcon(Separator, { width: { xs: 18, lg: 26 }, height: 2 }),
    TrackerBattery: TrackerBattery,
  });

  const getStatusIcons = (): IconSet => {
    return {
      //responsive
      Battery: responsiveIcon(Battery, { width: { xs: 45, lg: 64 }, height: { xs: 45, lg: 64 } }),
      BatteryInvalid: responsiveIcon(BatteryInvalid, {
        width: { xs: 45, lg: 64 },
        height: { xs: 45, lg: 64 },
      }),
      Grid: responsiveIcon(Grid, { width: { xs: 45, lg: 64 }, height: { xs: 45, lg: 64 } }),
      GridInvalid: responsiveIcon(GridInvalid, {
        width: { xs: 45, lg: 64 },
        height: { xs: 45, lg: 64 },
      }),
      Inverter: responsiveIcon(StatusInverter, {
        width: { xs: 17, lg: 30 },
        height: { xs: 11, lg: 20 },
      }),
      Tracker: responsiveIcon(StatusTracker, { width: { xs: 21, lg: 38 }, height: { xs: 10, lg: 19 } }),
      StatusMark: responsiveIcon(StatusMark, { width: { xs: 45, lg: 64 }, height: { xs: 45, lg: 64 } }),
      SafeOverridePopUp: responsiveIcon(SafeOverridePopUpIcon, {
        width: { xs: 9, lg: 14 },
        height: { xs: 9, lg: 14 },
      }),

      // unresponsive
      Ok: Ok,
      Warning: Warning,
      Error: Error,
      Undefined: Undefined,
    };
  };

  const getErrorIcons = (): IconSet => ({
    DataPointError: paddedResponsiveIcon(DataPointErrorIcon, {
      width: { xs: 12, lg: 20 },
      height: { xs: 12, lg: 20 },
    }),
    HighSeverityError: HighSeverityError,
    MildSeverityError: MildSeverityError,
    LowSeverityError: LowSeverityError,
    UndefinedSeverityError: UndefinedSeverityError,
    MultisiteHighSeverityError: MultisiteHighSeverityError,
    MultisiteMildSeverityError: MultisiteMildSeverityError,
    MultisiteLowSeverityError: MultisiteLowSeverityError,
    MultisiteUndefinedSeverityError: MultisiteUndefinedSeverityError,
    EmergencyError: EmergencyErrorIcon,
    EmergencyErrorHover: EmergencyErrorHover,
  });
  const getScheduleCommandIcons = (): IconSet => ({
    ExistsScheduledCommand: responsiveIcon(ExistsScheduledCommandIcon, {
      width: { xs: 16, lg: 24 },
      height: { xs: 16, lg: 24 },
    }),
    Recurrence: (props) => <RecurrenceIcon width={15} height={15} {...props} />,
    ActiveScheduledCommand: (props) => <ActiveScheduledCommandIcon width={20} height={14} {...props} />,
  });

  const getDiffuseOptimizationIcons = (): IconSet => ({
    DiffuseOptimizationOn: responsiveIcon(DiffuseOptimizationOn, {
      width: { xs: 29, lg: 46 },
      height: { xs: 28, lg: 45 },
    }),
  });

  const getGridIcons = (): IconSet => ({
    Delete: responsiveIcon(GridDelete, { width: { xs: 14, lg: 16 }, height: { xs: 14, lg: 16 } }),
    Edit: responsiveIcon(GridEdit, { width: { xs: 14, lg: 18 }, height: { xs: 14, lg: 18 } }),
  });

  const getLossAnalysisIcons = (): IconSet => ({
    AvailableSolarEnergy: responsiveIcon(AvailableSolarEnergyIcon, {
      width: { xs: 27.75, lg: 37 },
      height: { xs: 27.75, lg: 37 },
    }),
    ActualProduction: responsiveIcon(ActualProductionIcon, {
      width: { xs: 27.75, lg: 37 },
      height: { xs: 27.75, lg: 37 },
    }),
    Losses: responsiveIcon(LossesIcon, { width: { xs: 27.75, lg: 37 }, height: { xs: 27.75, lg: 37 } }),
    EmptyState: responsiveIcon(EmptyStateIcon, {
      width: { xs: 140, lg: 154 },
      height: { xs: 40, lg: 65 },
    }),
  });
  let icons: IconSet;
  switch (iconCategory) {
    case IconCategory.Reason:
      icons = getReasonIcons();
      break;
    case IconCategory.SafetyReason:
      icons = getSafetyReasonIcons();
      break;
    case IconCategory.Error:
      icons = getErrorIcons();
      break;
    case IconCategory.Status:
      icons = getStatusIcons();
      break;
    case IconCategory.FileCommands:
      icons = getFileCommandsIcons();
      break;
    case IconCategory.Loaders:
      icons = getLoadersIcons();
      break;
    case IconCategory.Fields:
      icons = getFieldsIcons();
      break;
    case IconCategory.Soma:
      icons = getSomaIcons();
      break;
    case IconCategory.Auxiliaries:
      icons = getAuxiliariesIcons();
      break;
    case IconCategory.ScheduleCommand:
      icons = getScheduleCommandIcons();
      break;
    case IconCategory.DiffuseOptimization:
      icons = getDiffuseOptimizationIcons();
      break;
    case IconCategory.Grid:
      icons = getGridIcons();
      break;
    case IconCategory.LossAnalysis:
      icons = getLossAnalysisIcons();
      break;
    default:
      icons = getGeneralIcons();
      break;
  }
  if (!icons[iconName]) {
    console.error(`Icon ${iconName} not found: `);
  }
  return icons[iconName];
};

const iconCache = new Map<string, IconSet[string]>();

const getIcons = (iconName: string, iconCategory: IconCategory) => {
  const key = `${iconCategory}:${iconName}`;
  const cachedIcon = iconCache.get(key);
  if (cachedIcon) {
    return cachedIcon;
  }

  const Icon = createIcon(iconName, iconCategory);
  iconCache.set(key, Icon);
  return Icon;
};

export default getIcons;
